export function initHeader() {
    const header = document.querySelector('header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 0) {
                header.classList.add('scrolled');
            }
            else {
                header.classList.remove('scrolled');
            }
        });
    }
}
export function initMobileMenu() {
    const menuBtn = document.querySelector('#menu-btn');
    const menu = document.querySelector('.menu-container');
    const body = document.body;
    if (menuBtn && menu) {
        menuBtn.addEventListener('click', () => {
            menuBtn.classList.toggle('active');
            menu.classList.toggle('open');
            body.classList.toggle('menu-open');
        });
    }
}
